var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"py-2 mb-0",attrs:{"variant":"danger","show":""}},[_c('div',{staticClass:"alert-body py-0 d-flex w-100 align-items-center justify-content-center"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("validation_warning_to_bottom"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }